import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ExternalLink, Download, Video, FileText, ChevronRight, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const MegazoneDownloadsPage = () => {
  const [activeTab, setActiveTab] = useState("tiktok");

  const tutoriais = [
    {
      id: "tiktok",
      title: "Como ganhar seguidores no TikTok",
      link: "https://megazonedownloads.comunidades.net/como-ganhar-seguidores-tiktok",
      description: "Aprenda estratégias eficazes para aumentar seus seguidores no TikTok e ganhar mais visibilidade.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-QUDdnkB5xzQQhkCyMO9YnYsz.png?st=2023-11-25T02%3A27%3A50Z&se=2023-11-25T04%3A27%3A50Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T22%3A27%3A14Z&ske=2023-11-25T22%3A27%3A14Z&sks=b&skv=2021-08-06&sig=FwGHKCCHKYzAZ/Ik/Aq4UxA7hJcUcG0Wl2n5TxiRMYE%3D"
    },
    {
      id: "site",
      title: "Criando um site de downloads na Comunidade.net",
      link: "https://megazonedownloads.comunidades.net/criando-um-site-de-dowlonds-megazone-dowlonds",
      description: "Tutorial completo para criar seu próprio site de downloads usando a plataforma Comunidade.net",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-ySdKxQ4a7o8SVLBTqoBLXNgJ.png?st=2023-11-25T02%3A27%3A59Z&se=2023-11-25T04%3A27%3A59Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-25T01%3A42%3A41Z&ske=2023-11-26T01%3A42%3A41Z&sks=b&skv=2021-08-06&sig=95Qpv2bNX3j%2BNLaMMH7%2BUzwvTfTWgQ5z5/9hhAXbfZw%3D"
    },
    {
      id: "sites",
      title: "Sites mais usados na internet",
      link: "https://megazonedownloads.comunidades.net/sites-mais-usados-na-internet",
      description: "Conheça os sites mais populares e utilizados na internet atualmente.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-wCT1J5wLB5i7kkCNqBJeGOSN.png?st=2023-11-25T02%3A28%3A08Z&se=2023-11-25T04%3A28%3A08Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T23%3A51%3A16Z&ske=2023-11-25T23%3A51%3A16Z&sks=b&skv=2021-08-06&sig=KfN9XDLOaxeRFoJsrBnKegOZmRFfg3aQHCzlPcYLX7I%3D"
    },
    {
      id: "melhores",
      title: "Os melhores sites da internet",
      link: "https://megazonedownloads.comunidades.net/os-melhores-sites-da-internet",
      description: "Uma seleção curada dos melhores sites da internet para diversas finalidades.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-wZYVhwrZAUdDUjnGBjXzfZHS.png?st=2023-11-25T02%3A28%3A17Z&se=2023-11-25T04%3A28%3A17Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T23%3A50%3A49Z&ske=2023-11-25T23%3A50%3A49Z&sks=b&skv=2021-08-06&sig=3Ux4fP0eLlmBxnCgXJKJF30bSY%2BXCTJFZjZMaaxBZj8%3D"
    },
    {
      id: "chatgpt",
      title: "Criando vídeos pelo ChatGPT",
      link: "https://megazonedownloads.comunidades.net/criando-video-pro-canal-pelo-chatgpt",
      description: "Aprenda como utilizar o ChatGPT para criar roteiros e conteúdo para seus vídeos.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-2mPYnkF4KwpLUQfqT6KKaZ3R.png?st=2023-11-25T02%3A28%3A26Z&se=2023-11-25T04%3A28%3A26Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-25T01%3A43%3A12Z&ske=2023-11-26T01%3A43%3A12Z&sks=b&skv=2021-08-06&sig=qyM%2BWZUB%2BX3ukZzbxPbBVrLCH9iiPmq5uY13xTxEh5c%3D"
    },
    {
      id: "adobe",
      title: "Tutorial Adobe Express",
      link: "https://megazonedownloads.comunidades.net/tutorial-adobe-express",
      description: "Tutorial completo sobre como usar o Adobe Express para criar designs incríveis.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-7nLlBNPxdwg8Hl3mkULhb3gC.png?st=2023-11-25T02%3A28%3A35Z&se=2023-11-25T04%3A28%3A35Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-25T01%3A48%3A21Z&ske=2023-11-26T01%3A48%3A21Z&sks=b&skv=2021-08-06&sig=8B4WGaUPm6hAOthCXwh8UdBXgayRHHTtk8nOYxkBV1c%3D"
    },
    {
      id: "clideo",
      title: "Como remover o áudio do vídeo no editor Clideo",
      link: "https://megazonedownloads.comunidades.net/como-remover-o-audio-do-video-no-editor-clideo",
      description: "Aprenda a remover o áudio de vídeos usando o editor online Clideo.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-n0jkqJU7TZZPaB0VqUzW2xqc.png?st=2023-11-25T02%3A28%3A44Z&se=2023-11-25T04%3A28%3A44Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T22%3A27%3A28Z&ske=2023-11-25T22%3A27%3A28Z&sks=b&skv=2021-08-06&sig=hVmkO/TOGnwj%2BFHJYzuDI4FLkEfNSAJhYx6HlR6%2BQXs%3D"
    },
    {
      id: "blog",
      title: "Como criar um blog",
      link: "https://megazonedownloads.comunidades.net/como-criar-1-blog",
      description: "Guia completo para criar seu próprio blog do zero.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-5C9bkxCFB6BkqRTLtI9qiV4b.png?st=2023-11-25T02%3A28%3A54Z&se=2023-11-25T04%3A28%3A54Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T23%3A50%3A25Z&ske=2023-11-25T23%3A50%3A25Z&sks=b&skv=2021-08-06&sig=vdFo%2BkbtjFOTGGTZh26Rn6KLw5lS6fMcpbZxpM4Bq5g%3D"
    },
    {
      id: "youtube",
      title: "Criando um vídeo no YouTube pela nova opção inspiração",
      link: "https://megazonedownloads.comunidades.net/criando-um-video-no-youtube-pela-nova-opcao-inspir",
      description: "Aprenda a criar vídeos usando a nova funcionalidade de inspiração do YouTube.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-L6Jx0thMpPWQFq7IxvPVJ6zh.png?st=2023-11-25T02%3A29%3A03Z&se=2023-11-25T04%3A29%3A03Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T22%3A27%3A31Z&ske=2023-11-25T22%3A27%3A31Z&sks=b&skv=2021-08-06&sig=Buc4lK5TtGxRqCmrGPVzI4/BiqSgWl7WQYQu0tZEj9I%3D"
    },
    {
      id: "animacao",
      title: "Crie texto em animação",
      link: "https://megazonedownloads.comunidades.net/crie-texto-em-animacao",
      description: "Tutorial para criar textos animados para seus vídeos e apresentações.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-5Zfx3Cb0JVrUCTLZSzgKsGaI.png?st=2023-11-25T02%3A29%3A12Z&se=2023-11-25T04%3A29%3A12Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T22%3A27%3A26Z&ske=2023-11-25T22%3A27%3A26Z&sks=b&skv=2021-08-06&sig=i/KBkrKZE0r9ksQiYmwkwXAXPdhkp1K90NLtXMQPBWY%3D"
    },
    {
      id: "webradio",
      title: "Web Rádio",
      link: "https://webradioral.comunidades.net/",
      description: "Tudo sobre web rádio e como criar sua própria rádio online.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-eA8tCmFSHnXN0Qh5dvlA3n7j.png?st=2023-11-25T02%3A29%3A21Z&se=2023-11-25T04%3A29%3A21Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-25T01%3A40%3A31Z&ske=2023-11-26T01%3A40%3A31Z&sks=b&skv=2021-08-06&sig=1jYhALgw2uF8c2x2GnCL1n%2BjnSAxzYhEhpRfzV%2BgPzE%3D"
    },
    {
      id: "series2",
      title: "As melhores séries do Japão (Parte 2)",
      link: "https://megazonedownloads.comunidades.net/as-melhores-series-do-japao2",
      description: "Continuação da lista com as melhores séries japonesas de todos os tempos.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-WlfTTzIvXOgGRi2sSq8nqt3i.png?st=2023-11-25T02%3A29%3A30Z&se=2023-11-25T04%3A29%3A30Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-25T01%3A50%3A26Z&ske=2023-11-26T01%3A50%3A26Z&sks=b&skv=2021-08-06&sig=NQdCxSUdNiTQCmNLLjnfTWAyAi7qXu1b%2BTrGwbxETqA%3D"
    },
    {
      id: "series3",
      title: "As melhores séries do Japão (Parte 3)",
      link: "https://megazonedownloads.comunidades.net/as-melhores-series-do-japao3",
      description: "Terceira parte da lista com as melhores séries japonesas de todos os tempos.",
      image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-ct6DYAeKceEiQOX0yD2moI7R/user-f0xXHxP7OLYpXKo5T8F4XHV9/img-DUGbwBg0VZPBN3CIQGbMZeaU.png?st=2023-11-25T02%3A29%3A40Z&se=2023-11-25T04%3A29%3A40Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-11-24T22%3A27%3A33Z&ske=2023-11-25T22%3A27%3A33Z&sks=b&skv=2021-08-06&sig=uCCsYajEBSWuuO/k0rYhFbL/rVBZ0OGNadbZFM9clCg%3D"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <div className="pt-20 px-4 md:px-8 max-w-7xl mx-auto w-full flex-grow">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8 gap-4">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold">Megazone Downloads</h1>
            <p className="text-muted-foreground mt-2">
              Tutoriais, dicas e downloads para ajudar você a criar conteúdo incrível online
            </p>
          </div>
          <div className="flex gap-3">
            <Button asChild>
              <a href="https://megazonedownloads.comunidades.net/" target="_blank" rel="noopener noreferrer">
                <ExternalLink className="mr-2 h-4 w-4" />
                Visitar Site Original
              </a>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/series-japonesas">
                Ver Séries Japonesas
              </Link>
            </Button>
          </div>
        </div>

        <Tabs defaultValue="tutoriais" className="w-full">
          <TabsList className="mb-8 flex flex-wrap">
            <TabsTrigger value="tutoriais">Tutoriais</TabsTrigger>
            <TabsTrigger value="sites">Sites Recomendados</TabsTrigger>
            <TabsTrigger value="videos">Vídeos</TabsTrigger>
            <TabsTrigger value="downloads">Downloads</TabsTrigger>
          </TabsList>
          
          <TabsContent value="tutoriais" className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {tutoriais.map((tutorial) => (
                <Card key={tutorial.id} className="overflow-hidden flex flex-col h-full">
                  <div className="aspect-video overflow-hidden">
                    <img 
                      src={tutorial.image} 
                      alt={tutorial.title} 
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                    />
                  </div>
                  <CardHeader className="p-4">
                    <CardTitle className="text-xl">{tutorial.title}</CardTitle>
                    <CardDescription className="line-clamp-2">{tutorial.description}</CardDescription>
                  </CardHeader>
                  <CardFooter className="p-4 mt-auto">
                    <Button asChild variant="outline" className="w-full">
                      <a href={tutorial.link} target="_blank" rel="noopener noreferrer">
                        <ExternalLink className="mr-2 h-4 w-4" />
                        Acessar Tutorial
                      </a>
                    </Button>
                  </CardFooter>
                </Card>
              ))}
            </div>
          </TabsContent>
          
          <TabsContent value="sites" className="space-y-8">
            <Card className="p-6">
              <h2 className="text-2xl font-bold mb-4">Sites Mais Usados na Internet</h2>
              <p className="mb-4">Confira a lista completa dos sites mais populares e utilizados na internet atualmente.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/sites-mais-usados-na-internet" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Ver Lista Completa
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/os-melhores-sites-da-internet" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Os Melhores Sites
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <Link to="/melhores-sites">
                    <ChevronRight className="mr-2 h-4 w-4" />
                    Melhores Sites (Nosso Guia)
                  </Link>
                </Button>
                <Button asChild variant="outline">
                  <Link to="/melhores-sites-completo">
                    <ChevronRight className="mr-2 h-4 w-4" />
                    Guia Completo de Sites
                  </Link>
                </Button>
              </div>
            </Card>
            
            <Card className="p-6">
              <h2 className="text-2xl font-bold mb-4">Comunidades e Blogs</h2>
              <p className="mb-4">Crie seu próprio site ou blog usando estas plataformas recomendadas:</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Button asChild variant="outline">
                  <a href="https://comunidades.net/" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Comunidades.net
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://www.blogger.com/" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Blogger
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://wordpress.com/pt-br/" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    WordPress
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/como-criar-1-blog" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    Tutorial: Como Criar um Blog
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/criando-um-site-de-dowlonds-megazone-dowlonds" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    Tutorial: Criando um Site de Downloads
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://webradioral.comunidades.net/" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Web Rádio
                  </a>
                </Button>
              </div>
            </Card>
          </TabsContent>
          
          <TabsContent value="videos" className="space-y-8">
            <Card className="p-6">
              <h2 className="text-2xl font-bold mb-4">Criação de Vídeos</h2>
              <p className="mb-4">Tutoriais e ferramentas para criar vídeos incríveis:</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/criando-video-pro-canal-pelo-chatgpt" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    Criando Vídeos pelo ChatGPT
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/tutorial-adobe-express" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    Tutorial Adobe Express
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/como-remover-o-audio-do-video-no-editor-clideo" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    Remover Áudio com Clideo
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/criando-um-video-no-youtube-pela-nova-opcao-inspir" target="_blank" rel="noopener noreferrer">
                    <Youtube className="mr-2 h-4 w-4" />
                    Vídeos com YouTube Inspiração
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/crie-texto-em-animacao" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    Crie Texto em Animação
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://www.capcut.com/" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    CapCut Online
                  </a>
                </Button>
              </div>
            </Card>
            
            <Card className="p-6">
              <h2 className="text-2xl font-bold mb-4">Séries Japonesas</h2>
              <p className="mb-4">Confira nossas coleções de séries japonesas:</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/as-melhores-series-do-japao2" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    As Melhores Séries do Japão (Parte 2)
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/as-melhores-series-do-japao3" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    As Melhores Séries do Japão (Parte 3)
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <Link to="/series-japonesas">
                    <ChevronRight className="mr-2 h-4 w-4" />
                    Ver Todas as Séries
                  </Link>
                </Button>
              </div>
            </Card>
          </TabsContent>
          
          <TabsContent value="downloads" className="space-y-8">
            <Card className="p-6">
              <h2 className="text-2xl font-bold mb-4">Ferramentas de Download</h2>
              <p className="mb-4">Ferramentas úteis para download de conteúdo:</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Button asChild variant="outline">
                  <a href="https://www.clipto.com/pt/media-downloader/youtube-downloader" target="_blank" rel="noopener noreferrer">
                    <Download className="mr-2 h-4 w-4" />
                    Clipto YouTube Downloader
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://www.oneimagevideo.com/" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    One Image Video
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://clideo.com" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Clideo Editor
                  </a>
                </Button>
              </div>
            </Card>
            
            <Card className="p-6">
              <h2 className="text-2xl font-bold mb-4">Redes Sociais</h2>
              <p className="mb-4">Tutoriais e dicas para redes sociais:</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <Button asChild variant="outline">
                  <a href="https://megazonedownloads.comunidades.net/como-ganhar-seguidores-tiktok" target="_blank" rel="noopener noreferrer">
                    <FileText className="mr-2 h-4 w-4" />
                    Como Ganhar Seguidores no TikTok
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://www.tiktok.com/@gameover2661" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    TikTok @gameover2661
                  </a>
                </Button>
                <Button asChild variant="outline">
                  <a href="https://rumble.com/register/FARIAS/" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    Criar Conta no Rumble
                  </a>
                </Button>
              </div>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
      <Footer />
    </div>
  );
};

export default MegazoneDownloadsPage;